export default function InviteStaff() {
    return (
      <div style={{ padding: "2rem" }}>
        <h2>Invite a Staff Member</h2>
        <p>This page will allow you to send a staff signup link.</p>
      </div>
    );
  }
  